export default {
  sort: 4,
  path: '/modifyRecord/:id',
  name: 'ModifyRecord',
  component: () => import('@/views/modifyRecord'),
}


// WEBPACK FOOTER //
// ./src/router/modules/modifyRecord.js